/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateCondition200Response,
  CreateConditionRequest,
  ListConditions200Response,
  ListOperations400Response,
  UpdateConditionRequest,
} from '../models/index';
import {
    CreateCondition200ResponseFromJSON,
    CreateCondition200ResponseToJSON,
    CreateConditionRequestFromJSON,
    CreateConditionRequestToJSON,
    ListConditions200ResponseFromJSON,
    ListConditions200ResponseToJSON,
    ListOperations400ResponseFromJSON,
    ListOperations400ResponseToJSON,
    UpdateConditionRequestFromJSON,
    UpdateConditionRequestToJSON,
} from '../models/index';

export interface CreateConditionOperationRequest {
    createConditionRequest: CreateConditionRequest;
}

export interface ListConditionsRequest {
    page?: number;
    count?: number;
    sort?: ListConditionsSortEnum;
    id?: string;
    serviceName?: string;
    expenseItemName?: string;
    feePercentage?: string;
}

export interface UpdateConditionOperationRequest {
    ifMatch: number;
    id: string;
    updateConditionRequest: UpdateConditionRequest;
}

/**
 * 
 */
export class ConditionsApi extends runtime.BaseAPI {

    /**
     * 経済条件作成
     */
    async createConditionRaw(requestParameters: CreateConditionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCondition200Response>> {
        if (requestParameters['createConditionRequest'] == null) {
            throw new runtime.RequiredError(
                'createConditionRequest',
                'Required parameter "createConditionRequest" was null or undefined when calling createCondition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/conditions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateConditionRequestToJSON(requestParameters['createConditionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCondition200ResponseFromJSON(jsonValue));
    }

    /**
     * 経済条件作成
     */
    async createCondition(requestParameters: CreateConditionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCondition200Response> {
        const response = await this.createConditionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 経済条件一覧
     */
    async listConditionsRaw(requestParameters: ListConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListConditions200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['serviceName'] != null) {
            queryParameters['service_name'] = requestParameters['serviceName'];
        }

        if (requestParameters['expenseItemName'] != null) {
            queryParameters['expense_item_name'] = requestParameters['expenseItemName'];
        }

        if (requestParameters['feePercentage'] != null) {
            queryParameters['fee_percentage'] = requestParameters['feePercentage'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/conditions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListConditions200ResponseFromJSON(jsonValue));
    }

    /**
     * 経済条件一覧
     */
    async listConditions(requestParameters: ListConditionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListConditions200Response> {
        const response = await this.listConditionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 経済条件更新
     */
    async updateConditionRaw(requestParameters: UpdateConditionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling updateCondition().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCondition().'
            );
        }

        if (requestParameters['updateConditionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateConditionRequest',
                'Required parameter "updateConditionRequest" was null or undefined when calling updateCondition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/conditions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateConditionRequestToJSON(requestParameters['updateConditionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 経済条件更新
     */
    async updateCondition(requestParameters: UpdateConditionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateConditionRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ListConditionsSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListConditionsSortEnum = typeof ListConditionsSortEnum[keyof typeof ListConditionsSortEnum];
